import { Post, Put } from '../helpers';

export const PublishProjectPreview = async (
  preview_event_uuid: string,
  base_event_uuid: string,
  url: string,
  projectChannel: number
): Promise<{ url: string; uuid: string }> => {
  return Post({
    path: `/v3/admin/events/preview/publish/${projectChannel}`,
    body: { preview_event_uuid, base_event_uuid, url },
  });
};

export const UpdateProjectPreviewPassword = async (projectPreviewUuid: string): Promise<{ password: string }> => {
  return Put({
    path: `/v3/admin/events/preview-password/${projectPreviewUuid}`,
  });
};
